/* eslint-disable react/destructuring-assignment */
import type { FC } from 'react';
import { Skeleton } from '@chakra-ui/react';
import type { SkeletonProps } from '@chakra-ui/react';

const breadcrumbsLoadedStyles = {
    padding: {
        base: '1rem',
        sm: '1rem 2rem',
        md: '1rem 0',
        lg: '1rem 0',
    },
};

const breadcrumbsUnloadedStyles = {
    height: '22px',
    marginX: { base: 4, sm: 8, md: 0 },
    marginY: 4,
    width: { base: '167px', sm: '183px' },
};

export const GiftCardsBreadcrumbsSkeleton: FC<SkeletonProps> = (props) => (
    <Skeleton
        {...props}
        {...(props.isLoaded ? breadcrumbsLoadedStyles : breadcrumbsUnloadedStyles)}
        lineHeight="short"
        data-testid="gift-cards-breadcrumbs-skeleton"
    />
);

export const GiftCardsTitleSkeleton: FC<SkeletonProps> = (props) => (
    <Skeleton
        {...props}
        height={props.isLoaded ? undefined : '60px'}
        width={{ base: 'calc(100%-32px)', md: '100%' }}
        marginX={{ base: 4, sm: 8, md: 0 }}
        data-testid="gift-cards-title-skeleton"
    />
);
export const GiftCardsCardContainerSkeleton: FC<SkeletonProps> = (props) => (
    <Skeleton
        {...props}
        minHeight={{ base: '432px', sm: '408px', md: '512px', lg: '488px' }}
        width="100%"
        data-testid="gift-cards-card-skeleton"
    />
);
export const GiftCardsYouGiveCardSkeleton: FC<SkeletonProps> = (props) => (
    <Skeleton
        {...props}
        height={
            props.isLoaded
                ? undefined
                : {
                      base: '1086px',
                      sm: '930px',
                      md: '428px',
                      lg: '380px',
                      xl: '344px',
                  }
        }
        width="100%"
        data-testid="gift-cards-you-give-skeleton"
    />
);
export const GiftCardsFAQCardSkeleton: FC<SkeletonProps> = (props) => (
    <Skeleton
        {...props}
        height={props.isLoaded ? undefined : { base: '765px', sm: '573px', md: '489px' }}
        width="100%"
        data-testid="gift-cards-FAQ-card-skeleton"
    />
);
